// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"abouts-us_subtitle__2h5do","container":"abouts-us_container__3_bj-"};